const ACTIVE_KEY = 'lw_first_run_intake_active'
const PENDING_KEY = 'lw_first_run_pending'
const ONE_HOUR_MS = 60 * 60 * 1000

export interface PendingFirstRunIntent {
  displayText: string
  prompt: string
}

export function isFirstRunIntakeActive(): boolean {
  try {
    return sessionStorage.getItem(ACTIVE_KEY) === '1'
  } catch {
    return false
  }
}

export function setFirstRunIntakeActive(): void {
  try {
    sessionStorage.setItem(ACTIVE_KEY, '1')
  } catch {
    /* sessionStorage unavailable */
  }
}

export function clearFirstRunIntakeActive(): void {
  try {
    sessionStorage.removeItem(ACTIVE_KEY)
  } catch {
    /* sessionStorage unavailable */
  }
}

export function storePendingFirstRunIntent(intent: PendingFirstRunIntent): void {
  try {
    sessionStorage.setItem(
      PENDING_KEY,
      JSON.stringify({ ...intent, ts: Date.now() }),
    )
  } catch {
    /* sessionStorage unavailable */
  }
}

export function consumePendingFirstRunIntent(): PendingFirstRunIntent | null {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY)
    if (!raw) return null
    sessionStorage.removeItem(PENDING_KEY)
    const parsed = JSON.parse(raw) as PendingFirstRunIntent & { ts?: number }
    if (!parsed?.prompt || !parsed?.displayText) return null
    if (parsed.ts && Date.now() - parsed.ts > ONE_HOUR_MS) return null
    return { displayText: parsed.displayText, prompt: parsed.prompt }
  } catch {
    return null
  }
}

export function resolveClientIntent(explicit?: string | null): string | undefined {
  if (explicit) return explicit
  return isFirstRunIntakeActive() ? 'first_run_intake' : undefined
}
